import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Phone as PhoneIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';
import Logo from '../../assets/images/varsityFile2.png'
import HeroImage from '../../assets/images/Hero1.jpg'

// Higher-order component to provide hooks to class component
const withHooks = (Component) => {
  return (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return <Component {...props} theme={theme} isMobile={isMobile} />;
  };
};

class HeroSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    // Trigger animation after component mounts
    setTimeout(() => {
      this.setState({ isVisible: true });
    }, 100);
  }

  render() {
    const { isMobile } = this.props;
    const { isVisible } = this.state;

    return (
      <Box
        className="hero-background"
        sx={{
          minHeight: '95vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Background Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            //background: 'linear-gradient(135deg, rgba(178, 35, 53, 0.9) 0%, rgba(178, 35, 53, 0.7) 100%)',
            zIndex: 1
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 4 }}
            columnSpacing={{ xs: 1, md: 4 }}
            alignItems="center"
            sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}
          >
            <Grid item xs={12} sm={8} md={7}>
              <Box
                sx={{
                  color: 'white',
                  textAlign: { xs: 'center', md: 'left' },
                  pt: { xs: 4, md: 0 }
                }}
                className={isVisible ? 'fade-in-up' : ''}
              >
                {/* Main Headline */}
                <Typography
                  variant="h1"
                  className="hero-title"
                  sx={{
                    fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                    fontWeight: 700,
                    lineHeight: 1.1,
                    mb: 3,
                    color: 'primary.main',
               //     textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                  }}
                >
                  STRENGTH LIVES{' '}
                  <Box component="span" sx={{
                    color: 'secondary.main',
                //    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                  }}>
                    HERE
                  </Box>
                </Typography>

                {/* Subtitle */}
                <Typography
                  variant="h4"
                  className="hero-subtitle"
                  sx={{
                    fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                    fontWeight: 400,
                    lineHeight: 1.4,
                    mb: 2,
                    opacity: 0.95,
                     color: 'secondary.main',
               //     textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                  }}
                >
                  Beginner and Advanced Programs
                </Typography>

                {/* Value Proposition */}
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.25rem' },
                    fontWeight: 300,
                    lineHeight: 1.6,
                    mb: 4,
                    opacity: 0.9,
                    maxWidth: '600px',
                    color: 'secondary.main',
                    overflowWrap: 'break-word',
                    wordWrap: 'break-word',
               //     textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                  }}
                >
                  Transform your body and mind in a community that celebrates every victory.
                  From your first rep to your personal best, we're here to guide your transformation.
                </Typography>

                {/* Key Benefits */}
                <Box sx={{ mb: 4 }}>
                  <Grid container spacing={2}>
                    {[
                      '✓ Expert Personal Trainers',
                      '✓ Beginner and Advanced Programs',
                      '✓ Supportive Community',
                      '✓ Modern Equipment'
                    ].map((benefit, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Typography
                          variant="body1"
                          sx={{
                            color: 'primary.main',
                            fontWeight: 500,
                            fontSize: { xs: '0.9rem', md: '1rem' }
                          }}
                        >
                          {benefit}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* Call-to-Action Buttons */}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    alignItems: { xs: 'stretch', sm: 'center' }
                  }}
                >
                <Button
                  component="a"
                  href="https://varsity-fitness.exercise.com/packages/61874/purchase/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  size="large"
                  sx={{
                    backgroundColor: 'secondary.main',
                    color: 'text.primary',
                    borderRadius: '50px',
                    px: 4,
                    py: 2,
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    fontWeight: 600,
                    textTransform: 'none',
                    boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
                    '&:hover': {
                      backgroundColor: 'secondary.light',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 12px 35px rgba(255, 215, 0, 0.6)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Get Started Today
                </Button>
                <Button
                  component="a"
                  href="https://varsity-fitness.exercise.com/packages/61874/purchase/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  size="large"
                  sx={{
                    backgroundColor: 'secondary.main',
                    color: 'text.primary',
                    borderRadius: '50px',
                    px: 4,
                    py: 2,
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    fontWeight: 600,
                    textTransform: 'none',
                    boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
                    '&:hover': {
                      backgroundColor: 'secondary.light',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 12px 35px rgba(255, 215, 0, 0.6)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Start 7-Day Free Trial
                </Button>
                </Box>

                {/* Trust Indicators */}
                <Box sx={{ pt: 3, display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, width: '100%' }}>

                  <Box sx={{ display: 'flex', gap: 4, flexWrap: 'nowrap', flexDirection: 'row', alignItems: 'center', overflowX: 'auto' }}>
                    <Typography variant="body2" sx={{ color: 'secondary.main', fontWeight: 500, px: 1, whiteSpace: 'nowrap' }}>
                      Licensed
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'secondary.main', fontWeight: 500, px: 1, whiteSpace: 'nowrap' }}>
                      Insured
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'secondary.main', fontWeight: 500, px: 1, whiteSpace: 'nowrap' }}>
                      Certified Trainers
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Right Side - Could be used for images or video */}
            <Grid item xs={12} sm={4} md={5} container justifyContent="flex-end" alignItems="center"   >
              <Box
                component="img"
                src={Logo}
                alt="Varsity Fitness Logo"
                sx={{
                  display: { xs: 'none', md: 'block' },
                  width: { xs: '70%', sm: '60%', md: '100%' },
                  maxWidth: 600,
                  height: 'auto'
                }}
                className={isVisible ? 'fade-in-right' : ''}
              />
            </Grid>
          </Grid>
        </Container>

        {/* Scroll Indicator */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 30,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
            animation: 'bounce 2s infinite'
          }}
        >
          <Box
            sx={{
              width: 2,
              height: 30,
              backgroundColor: 'secondary.main',
              borderRadius: 1,
              opacity: 0.8
              
            }}
          />
        </Box>

        {/* Add bounce animation */}
        <style>{`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateX(-50%) translateY(0);
            }
            40% {
              transform: translateX(-50%) translateY(-10px);
            }
            60% {
              transform: translateX(-50%) translateY(-5px);
            }
          }
        `}</style>
        
      </Box>
      
    );
  }
}

export default withHooks(HeroSection);
